import CompaniesIndex from './screens/CompaniesIndex';

// TODO this will be changed to index
export default CompaniesIndex;